import React from 'react';
import { Box, Typography, Grid, Card, CardContent, IconButton, useTheme } from '@mui/material';
import {
  ChevronRight as ArrowIcon,
  LocalShipping,
  LocationOn,
  LocationOnOutlined,
  PlaceOutlined,
  Category,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  PageHeader,
} from '../../components/SharedPageParts';

interface DashboardCard {
  title: string;
  subtitle: string;
  icon: React.ReactElement;
  iconBg: string;
  stats?: { label: string; value: number }[];
  action?: { label: string; onClick: () => void };
  path: string;
}
const haulMasterCards: DashboardCard[] = [
    {
      title: 'Load Locations',
      subtitle: 'Manage loading sites and materials availability',
      icon: <LocationOn sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      path: '/loadlocations',
    },
    {
      title: 'Dump Locations',
      subtitle: 'Manage dump sites and capacity',
      icon: <PlaceOutlined sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      path: '/dumplocations',
    },
    {
      title: 'Materials',
      subtitle: 'Manage material catalog and properties',
      icon: <Category sx={{ fontSize: 21 }} />,
      iconBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      path: '/materials',
    }];

const HaulMasterLivePage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: theme.palette.background.default }}>
    <Box className="MuiBox-root-margin" sx={{ px: 1, mx: 'auto'}}>
      
      <PageHeader
                                  title="Haul Master"
                                  Icon={LocationOnOutlined}
                                  onBack={() => navigate('/')}
                                  backLabel="Back to Dashboard"
                                  subtitle="Manage load/dump locations and material catalog"
                                />

              <Grid container spacing={3}>
                {haulMasterCards.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Card
                      sx={{
                        height: '100%',
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        border: `1px solid ${theme.palette.divider}`,
                        '&:hover': { transform: 'translateY(-4px)', boxShadow: theme.palette.mode === 'light' ? '0 12px 24px rgba(0,0,0,0.1)' : '0 12px 24px rgba(0,0,0,0.3)' },
                      }}
                      onClick={() => navigate(card.path)}
                    >
                      <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                          <Box sx={{ width: 56, height: 56, borderRadius: 2, background: card.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: theme.palette.text.primary }}>
                            {card.icon}
                          </Box>
                          <IconButton size="small" sx={{ color: theme.palette.text.secondary }}>
                            <ArrowIcon />
                          </IconButton>
                        </Box>
      
                        <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 600, mb: 1 }}>
                          {card.title}
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.text.primary, mb: 2, flexGrow: 1 }}>
                          {card.subtitle}
                        </Typography>
      
                        {card.stats && (
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {card.stats.map((stat, i) => (
                              <Box key={i} sx={{ backgroundColor: theme.palette.background.default, px: 2, py: 1, borderRadius: 1, flex: '1 1 auto', minWidth: 60 }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }}>
                                  {stat.label}
                                </Typography>
                                <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontWeight: 700 }}>
                                  {stat.value}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
      
                        {card.action && (
                          <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #475569' }}>
                            <Typography
                              variant="body2"
                              sx={{ color: '#667eea', fontWeight: 600, cursor: 'pointer' }}
                              onClick={(e) => { e.stopPropagation(); card.action?.onClick(); }}
                            >
                              {card.action.label}
                            </Typography>
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          <Box sx={{ backgroundColor: '#29374dff', borderRadius: 2, p:1, mt:4 }}>
            <Typography variant="h5" sx={{mt:4, mb:2, pl:1, color: theme.palette.text.primary}}><LocalShipping /> About Haul Master Live</Typography>
            <Typography variant="body2" sx={{mt:2, mb:1, pl:1, color: theme.palette.text.secondary}}>
            Haul Master Live managers all spatial and material data fro hauling operations. Configure load locations where materials are expected,
            dump locations for material disposal and maingtain a comprehensive material catalog with properties and classifications for real time tracking.
            </Typography>
        </Box>
    </Box>
    );
};
export default HaulMasterLivePage;